import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const SHORTCUTS: { keys: string; action: string }[] = [
  { keys: "1 to 9", action: "Choose a disposition" },
  { keys: "Enter", action: "Save and go to the next call" },
  { keys: "D", action: "Drop voicemail" },
  { keys: "H", action: "Hang up" },
  { keys: "M", action: "Mute or unmute" },
  { keys: "B", action: "Start or end a break" },
  { keys: "N", action: "Call the lead's next number after this call" },
  { keys: "?", action: "Show this list" },
];

interface ShortcutsHelpDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ShortcutsHelpDialog({ open, onOpenChange }: ShortcutsHelpDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Keyboard shortcuts</DialogTitle>
          <DialogDescription>While typing in notes or a text box, hold Ctrl or Cmd with the key.</DialogDescription>
        </DialogHeader>
        <div className="divide-y divide-border">
          {SHORTCUTS.map((shortcut) => (
            <div key={shortcut.keys} className="flex items-center justify-between gap-4 py-2 text-sm">
              <span>{shortcut.action}</span>
              <kbd className="rounded border border-border bg-muted px-2 py-0.5 font-mono text-xs">{shortcut.keys}</kbd>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
